import PropTypes from 'prop-types';
import { useState } from 'react';

import { getClassNames } from '../../../utils/util';

import { ReactComponent as InfoIcon } from '../../../resources/icons/tooltip.svg';

import './tooltip.scss';

const Tooltip = ({ text, maxWidth, toolTipLeft }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="tooltip" onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)}>
      <InfoIcon />
      {isVisible && (
        <div className="tooltip__body-container">
          <div
            className={`${getClassNames('tooltip__body', {
              left: toolTipLeft,
            })} `}
            style={{ maxWidth: maxWidth }}
          >
            <p>{text}</p>
          </div>
          <div className="tooltip__triangle-container">
            <div className="tooltip__triangle" />
            <div className="tooltip__triangle-border" />
          </div>
        </div>
      )}
    </div>
  );
};

Tooltip.propTypes = {
  text: PropTypes.string.isRequired,
  maxWidth: PropTypes.number.isRequired,
  toolTipLeft: PropTypes.bool,
};

Tooltip.defaultProps = {
  toolTipLeft: false,
};

export default Tooltip;
